import { createSlice } from '@reduxjs/toolkit';

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    selection: { type: 'subreddit', name: 'frontpage' },
  },
  reducers: {
    setSelection(state, action) {
      state.selection = action.payload;
    },
  },
});

export const { setSelection } = subscriptionSlice.actions;

export const selectSelection = state => state.subscription.selection;

export default subscriptionSlice.reducer;
